module.exports = __webpack_public_path__ + "img/borda-botao.8b080fdc.svg";